import React, { useEffect, useRef, useState } from 'react';
import { FaBriefcase, FaMobileAlt, FaSearch, FaAward, FaComments, FaBars, FaTimes, FaCheckCircle, FaUserTie, FaEnvelope, FaUser, FaHardHat } from 'react-icons/fa';
import { BsShieldCheck, BsGraphUp, BsClipboardCheck, BsBinoculars } from 'react-icons/bs';
import Slider from 'react-slick';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { toast } from 'react-toastify';


import styles from './LandingPage.module.css';
import FeaturedBusinessBanner from '../../components/FeaturedBusinessBanner/FeaturedBusinessBanner';
import SponsorDrawer from '../../components/FeaturedBusinessBanner/SponsorDrawer';

import { Link, useNavigate } from 'react-router-dom';


import "../../pages/Dashboards/SearchForm.module.css";

import Header from './components/Header';


import imageBizConnect from "../../assets/images/bussiness-home-vector.png";
import imageJobs from "../../assets/images/image_circle_post.png";
import imageConnect from "../../assets/images/image_circle_search.png";
import businessProcessImage from '../../assets/images/imgBusinessProcess.jpg';
import homeusersImage from "../../assets/images/homeownerslaptop.png";

import './BusinessGrowthPageNew.css';

import imageLogo from "../../assets/images/LogoBuildStart03.png";
import imageLogoNew from "../../assets/images/BSPLogoNew01.png";
import imageJobDone from "../../assets/images/imgJoneDone.jpg";
import imageSocialMedia from "../../assets/images/imgSocialMedia.jpg";

import SocialProofEngine from '../../components/SocialProof/SocialProofEngine'; // Adjust the 
import SearchFormComponent from "../../pages/Dashboards/SearchFormComponent";
import AiSearchAssistant from "../../components/AiSearchAssistant/AiSearchAssistant";
import AvailableJobs from '../../components/LiveJobs/AvailableJobs';

import AppDownloadSection from './components/AppDownloadSection'; 
import TestimonialsSection from './components/TestimonialsSection'; 
import FinalCtaSection from './components/FinalCtaSection'; 
import ConnectCtaSection from './components/ConnectCtaSection';
import PostJobCtaSection from './components/PostJobCtaSection';
import BuildStartSealOfApproval from './components/BuildStartSealOfApproval';
import ReadyToBuildCta from './components/ReadyToBuildCta';
import SocialConnectCta from './components/SocialConnectCta';
import ConsultantsSection from './components/ConsultantsSection';

import Footer from './components/Footer';


const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.hero}>
      {/* Content Container */}
      <div className={styles.heroContent}>
        
        {/* 1. Rating Badge */}
        <div className={styles.ratingBadge}>
          <span className={styles.stars}>★★★★★</span>
          <span className={styles.ratingText}>310+ Reviews</span>
        </div>

        {/* 2. Title with Light/Bold mixture */}
        <h1 className={styles.heroTitle}>
          Assemble Your A-Team <br />
          <span className={styles.heroTitleLight}>of Consultants, Trades & Suppliers</span>
          in Minutes
        </h1>

        {/* 3. Subtitle */}
        <p className={styles.heroSubtitle}>
          Connect with highly professional local professionals in seconds.
        </p>

        {/* 4. Search Bar - Wrapped to maintain layout */}
        <div className={styles.heroSearchWrapper}>
          <SearchFormComponent className={styles.landingPageSearchForm} />
        </div>

      </div>
    </section>
  );
};



const TrustedBy = ({ onBusinessClick }) => {
  return (
    <section className={styles.trustedBy}>
      {/* Pass the function down to the banner */}
      <FeaturedBusinessBanner onBusinessClick={onBusinessClick} />
    </section>
  );
};

const LeadExamplesSection = () => {
  const [jobsData, setJobsData] = useState([]);

  const handleGetJobs = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Jobs/GetLatestJobs`);
      setJobsData(response.data.slice(0, 10)); // Keep only 10 jobs
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to fetch jobs');
    }
  };

  useEffect(() => {
    handleGetJobs(); // Initial fetch

    const fetchInterval = setInterval(() => {
      handleGetJobs();
    }, 3 * 60 * 1000); // Fetch every 3 minutes

    const shiftInterval = setInterval(() => {
      setJobsData(prevJobs => {
        if (prevJobs.length === 0) return [];
        const newJobs = [...prevJobs];
        const firstJob = newJobs.shift();
        newJobs.push(firstJob);
        return newJobs;
      });
    }, 60 * 1000); // Shift every 1 minute

    return () => {
      clearInterval(fetchInterval);
      clearInterval(shiftInterval);
    };
  }, []);

  const jobSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <section className={styles.leadExamples}>
      <div className={styles.container}>
        <h2 className={`${styles.textCenter} ${styles.largeTitle}`}>Live Job Feed</h2>
        {jobsData.length > 0 ? (
          <Slider {...jobSettings}>
            {jobsData.map((job) => (
              <div key={job.job_id} className={styles.jobCard}>
                <h3>{job.name}</h3>
                <p>{job.postcode}</p>
                <p>{job.description}</p>
                <p>Budget: {job.budget || job.budgetAmount}</p>
              </div>
            ))}
          </Slider>
        ) : (
          <p className={styles.textCenter}>Loading jobs...</p>
        )}
      </div>
    </section>
  );
};

const PreconstructionProcess = () => {
  return (
    <section className={styles.preconstruction}>
      <div className={`${styles.container} ${styles.textCenter}`}>
        <h2>Power Your Preconstruction Process</h2>
        <div className={styles.processTags}>
          <button>General Contractors</button>
          <button className={styles.active}>Subcontractors</button>
          <button>Building Product Manufacturers</button>
          <button>Architect</button>
          <button>Air Conditioning</button>
          <button>All electrical services</button>
          <button>New Metering</button>
          <button>Power Poles</button>
          <button>Arborist</button>
          <button>Electrician</button>
          <button>Pools & Architect</button>
        </div>
      </div>
    </section>
  );
};

const Features = () => {
  const navigate = useNavigate();
  return (
    <section className={styles.features}>
      <div className={styles.container}>
        <div className={styles.featureItem}>
          <div className={styles.featureText}>
            <h2>For Consultants, Trades & Suppliers</h2>
            <p>Get in Front of Serious Clients
List your business on Build Start to connect with developers and renovators ready to hire.</p>
            <p>&nbsp;</p>
            <button className={styles.btnPrimary} onClick={() => navigate('/select-role')}>List your business with Build Start</button>
            <button className={styles.btnSecondary} onClick={() => navigate('/business-landing')}>Learn More</button>
          </div>
          <div className={styles.featureImage}>
            <img src={imageBizConnect} alt="Connect with clients" />
          </div>
        </div>
        <div className={`${styles.featureItem} ${styles.reverse}`}>
          <div className={styles.featureText}>
            <h2>For Property Developers, Builders & Renovators</h2>
            <p>Build with Confidence
Quickly assemble your trusted project team — from town planners to surveyors, engineers to certifiers and suppliers.</p>
            <p>&nbsp;</p>
            <button className={styles.btnPrimary} onClick={() => navigate('/select-role')}>Post a job</button>
          </div>
           <div className={styles.featureImage}>
            <img src={imageJobs} alt="Post a job" />
          </div>
        </div>




      </div>
    </section>
  );
};

const Stats = () => {
  return (
    <section className={styles.gettingStarted}>
      <div className={`${styles.container} ${styles.textCenter}`}>
        <h2>Why Developers & Renovators Choose Build Start</h2>
        <p>Build Start allows you to build relationships with and make connections with trusted professionals to help you get any job done.</p>
        <div className={styles.statsGrid}>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>10K+</span>
            <span className={styles.statLabel}>Active Projects</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>$3M+</span>
            <span className={styles.statLabel}>Job Spend</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>400+</span>
            <span className={styles.statLabel}>Metropolitan Areas Covered</span>
          </div>
        </div>
      </div>
    </section>
  );
};


// --- HOW IT WORKS SECTION ---
const HowItWorksSection = () => {

const homeownerSteps = [
  { 
    number: '01', 
    title: 'Chat Your Project to Life', 
    desc: 'Don\'t know technical jargon? Just tell our AI Virtual Assistant what you need (e.g., "Fix my roof"). It automatically builds a detailed job brief for you—no complex forms required.' 
  },
  { 
    number: '02', 
    title: 'Activate the Live Market', 
    desc: 'Your job will be matched to local professionals and they will receive instant notifications about your job, ensuring you get prompt interest.' 
  },
  { 
    number: '03', 
    title: 'Hire a "Verified Pro"', 
    desc: 'Receive quotes and view detailed profiles. We manually verify licenses, insurance, and ratings, so you can hire a "Verified Pro" with confidence.' 
  },
  { 
    number: '04', 
    title: 'Manage & Relax', 
    desc: 'Track progress and communicate with your team from your Build Start Dashboard. Whether it\'s a quick repair or a full renovation, keep everything organized in one secure place.' 
  },
];

  return (
    <section className="bs-how-section">
      <div className="bs-container-grid">
        
        {/* TEXT COLUMN */}
        <div className="bs-content-col">
          <h2>How It Works</h2>
          <p className="bs-subtitle">Here is how Build Start workds for you:</p>
          
          <div className="bs-steps-list">
            {homeownerSteps.map((step, index) => (
              <div key={index} className="bs-step-item">
                <div className="bs-step-number">{step.number}</div>
                <div className="bs-step-content">
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* IMAGE COLUMN (Using your existing code from previous steps) */}
        <div className="bs-image-col">
          <div className="bs-image-wrapper-styled">
             <img 
                src={homeusersImage} 
                alt="Process for Home Users" 
                className="bs-process-img" 
             />
             <div className="bs-quality-badge">Proof of quality</div>
          </div>
        </div>

      </div>
    </section>
  );
};



const GettingStarted = () => {
  return (
    <section className={styles.gettingStarted}>
      <div className={`${styles.container} ${styles.textCenter}`}>
        <h2>Getting Started is Simple</h2>
        <p>Your dream project is just a few clicks away. We’ve streamlined the process so you can focus on the results, not the search.</p>
        <div className={styles.steps}>
          <div className={styles.step}>
            <FaSearch size={50} className={styles.stepIcon} />
            <h3>1. Tell Us About Your Project</h3>
            <p>Use our advanced search or post a job brief. The more detail you provide, the better we can match you.</p>
          </div>
          <div className={styles.step}>
            <FaAward size={50} className={styles.stepIcon} />
            <h3>2. Receive Curated Matches</h3>
            <p>Forget endless lists. We’ll connect you with a select few Master Building professionals perfectly suited for your job.</p>
          </div>
          <div className={styles.step}>
            <FaComments size={50} className={styles.stepIcon} />
            <h3>3. Connect & Hire with Confidence</h3>
            <p>Chat directly, review portfolios, and hire the right pro, all within our secure platform. It’s that easy.</p>
          </div>
        </div>
                         <a href="/select-role" className={`${styles.btnPrimary} ${styles.largeButton}`}>Start Building Your A-Team Today</a>

      </div>
    </section>
  );
};


{/*

const FooterOLD = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerMain}>
          <div className={styles.footerAbout}>
            <div className={styles.logo}>Build Start</div>
            <p>Lorem ipsum dolor sit consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
            <div className={styles.socialIcons}>
              <a href="#facebook">f</a>
              <a href="#twitter">t</a>
              <a href="#linkedin">in</a>
              <a href="#instagram">o</a>
            </div>
          </div>
          <div className={styles.footerLinks}>
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#owners">For Home Owners</a></li>
              <li><a href="#professionals">For Professionals</a></li>
              <li><a href="#jobs">Jobs</a></li>
              <li><a href="#social">Social Media</a></li>
              <li><a href="#prices">Prices</a></li>
              <li><a href="#education">Education Resources</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className={styles.footerLinks}>
            <h4>Directory</h4>
            <ul>
              <li><a href="#ac">Airconditioning</a></li>
              <li><a href="#builders">Builders</a></li>
              <li><a href="#concreters">Concreters</a></li>
              <li><a href="#design">Design</a></li>
              <li><a href="#estimators">Estimators</a></li>
              <li><a href="#gardeners">Gardeners</a></li>
              <li><a href="#more">More......</a></li>
            </ul>
          </div>
          <div className={styles.footerLinks}>
            <h4>Resources</h4>
            <ul>
              <li><a href="#terminology">Terminology</a></li>
              <li><a href="#charts">Flow Charts</a></li>
              <li><a href="#tips">Design Tips</a></li>
              <li><a href="#how-tos">How tos</a></li>
              <li><a href="#support">Support</a></li>
              <li><a href="#process">Our Process</a></li>
              <li><a href="#library">Resource library</a></li>
            </ul>
          </div>
        </div>
      </div>
       <div className={styles.footerBottom}>
          <p>©Copyright 2026 https://buildstart.au | All Rights Reserved</p>
        </div>
    </footer>
  );
};
*/}



const ProblemSolutionSection = () => {

  const navigate = useNavigate();

  const problems = [
    "Wasting time asking “Does anyone know a good surveyor?” in forums and groups",
    "Projects delayed because the wrong consultant caused costly mistakes",
    "No easy way to verify licenses, insurance, or real reputation",
    "Stress and lost profit trying to pull together a reliable project team",
  ];

  const solutions = [
    "Vetted consultants, trades & suppliers with verified credentials",
    "Peer-trusted reviews & proven track records",
    "Fast matching to the exact expertise you need",
    "One platform to search, connect & hire with confidence",
  ];



  return (
    <section className={styles.problemSolution}>
      <div className={styles.container}>
        <div className={styles.problemSolutionHeader}>
          <h2>The Problem Developers, Builders & Renovators Face</h2>
          <p className={styles.subheadline}>
            Why traditional hunting through groups and forums slows projects and increases risk.
          </p>
        </div>

        <div className={styles.problemSolutionGrid}>
          {/* Problem Card */}
          {/* Renamed from .problemCol to .problemCard for clarity */}
          <div className={styles.problemCard}>
            <h3 className={styles.problemTitle}>The Problem</h3>
            <ul className={styles.problemList}>
              {problems.map((item, i) => (
                <li key={i} className={styles.problemItem}>
                  <span className={styles.problemDot} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Solution Card */}
          {/* The extra wrapping .solutionCol div is removed */}
          <div className={styles.solutionCard}>
            <h3 className={styles.solutionTitle}>The Build Start Solution</h3>
            <ul className={styles.solutionList}>
              {solutions.map((item, i) => (
                <li key={i} className={styles.solutionItem}>
                  <FaCheckCircle className={styles.solutionIcon} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className={styles.solutionCtas}>
              <button
                className={styles.btnPrimary}
                onClick={() => navigate("/select-role")}
              >
                Build My A-Team
              </button>
              <button
                className={styles.btnSecondary}
                onClick={() => navigate("/business-landing")}
              >
                List My Business
              </button>
            </div>
          </div>
        </div>

        <div className={styles.solutionReassure}>
            {/* Using spans directly is fine, or you can map over an array */}
            <span className={styles.reassureBadge}>Verified</span>
            <span>•</span>
            <span className={styles.reassureBadge}>License & Insurance checks</span>
            <span>•</span>
            <span className={styles.reassureBadge}>Portfolio review</span>
            <span>•</span>
            <span className={styles.reassureBadge}>Ongoing performance monitoring</span>
        </div>
      </div>
    </section>
  );
};




// --- Main Component ---

const BuildStartLandingPage = () => {
  const navigate = useNavigate();

  // 2. STATE MOVED HERE (Top Level)
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // 3. HANDLERS MOVED HERE (Top Level)
  const handleBusinessClick = (business) => {
    setSelectedBusiness(business);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setTimeout(() => setSelectedBusiness(null), 300);
  };

  return (
    <>
     <SocialProofEngine />
      <Header />
      <main>
        <Hero />
        
        {/* 4. Pass the handler down to TrustedBy */}
        <TrustedBy onBusinessClick={handleBusinessClick} />

        <ConsultantsSection />

        <PostJobCtaSection />

        <ConnectCtaSection />

        <SocialConnectCta />

        <ProblemSolutionSection />
        <HowItWorksSection />
        

        <AvailableJobs />

        {/* <LeadExamplesSection /> */}

        {/*<PreconstructionProcess /> */}
        {/* <Features /> */}
        <BuildStartSealOfApproval />

        <AppDownloadSection />

        <GettingStarted />
        <Stats />
        <TestimonialsSection />
        
        <ReadyToBuildCta />

      </main>
      <Footer />

      <AiSearchAssistant />

      <SponsorDrawer 
        business={selectedBusiness} 
        isOpen={isDrawerOpen} 
        onClose={closeDrawer} 
      />


    </>
  );
};

export default BuildStartLandingPage;
